import axios from 'axios';
const API_URL = process.env.REACT_APP_API;

export async function getSelectZonasActivas() {
  const response = await axios.get(`${API_URL}catalogos/zonas/active`);
  const data = response.data.doc.data;

  const dataSelect = data.map((row: any) => {
    const first = row.user?.first_name || '';
    const last = row.user?.father_last_name || '';

    const isSinResponsable = first.trim() === '-' && last.trim() === '-';

    return {
      ...row,
      label: row.name,
      value: row.id,
      user: isSinResponsable ? 'Sin responsable' : `${first} ${last}`.trim(),
    };
  });

  return dataSelect;
}

export async function getSelectRazon() {
  const response = await axios.get(`${API_URL}catalogos/motive/ASG`);
  const data = response.data.doc.data;
  let dataSelect: any = data;
  dataSelect.forEach((row: any) => {
    row.label = row.name;
    row.value = row.id;
  });
  return dataSelect;
}

export async function getAllPackages() {
  const response = await axios.get(`${API_URL}catalogos/package`);
  const data = response.data.doc.data;
  let dataSelect: any = data;
  dataSelect.forEach((row: any) => {
    row.label = row.location;
    row.value = row.id;
  });
  return dataSelect;
}

export async function getPackageListById(id: number) {
  const params = new URLSearchParams();
  const statusId = 9;

  if (id) {
    params.append('package_id', id.toString());
    params.append('status_id', statusId.toString());
  }
  const response = await axios.get(`${API_URL}catalogos/stock?${params}`);
  const data = response.data.doc.data;
  let dataSelect: any = data;
  dataSelect.forEach((row: any, index: number) => {
    row.count = index + 1;
    row.id = row.id;
    row.iccid = row.iccid;
    row.numero = row.msisdn;
  });
  return dataSelect;
}

export async function createAsignacion(body: any) {
  const { zone, ubicacion, razon, description, stock } = body;

  const response = await axios.post(
    `${API_URL}catalogos/package-movement/assign`,
    {
      zona_id: Number(zone),
      package_id: Number(ubicacion),
      motive_id: Number(razon),
      detail: description,
      stock: stock,
    }
  );
  return response;
}

export async function getAsignaciones(filters: any) {
  const params = new URLSearchParams();

  if (filters.init_date) params.set('init_date', filters.init_date);
  if (filters.end_date) params.set('end_date', filters.end_date);

  const queryString = params.toString();
  const url = `${API_URL}catalogos/package-movement/assign${
    queryString ? `?${queryString}` : ''
  }`;

  const response = await axios.get(url);
  const data = response.data.doc.data;
  return data;
}

export async function iccidValidation(iccid: string) {
  const response = await axios.get(
    `${API_URL}catalogos/package-movement/assign/validate/${iccid}`
  );
  const data = response.data.doc.data;
  return data;
}

export async function createAsignacionSimple(body: any) {
  const { zone, razon, description, stock } = body;

  const response = await axios.post(
    `${API_URL}catalogos/package-movement/assign/simple`,
    {
      zona_id: Number(zone),
      motive_id: Number(razon),
      detail: description,
      iccids: stock,
    }
  );
  return response;
}

export async function downloadAsignacionReportPDF(id: number) {
  const date = new Date().toISOString().split('T')[0];

  try {
    const response = await axios({
      url: `${API_URL}reports/package/${id}/document/pdf`,
      method: 'GET',
      responseType: 'blob',
    });

    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `REPORTE-ASIGNACION-${id}-${date}.pdf`);
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 0);
  } catch (error: any) {
    const parsed = await error.response.data.text();
    return JSON.parse(parsed);
  }
}
